import React from 'react';
import { Banner } from '../Banner/Banner';
import './LayoutWrapper.scss';

interface LayoutWrapperProps {
    children: React.ReactNode;
    layoutExperiment: string;
    organizerId: string;
    hasPermissionToEditOrganizationInfo: boolean;
}

export const LayoutWrapper: React.FunctionComponent<LayoutWrapperProps> = ({
    children,
    layoutExperiment,
    organizerId,
    hasPermissionToEditOrganizationInfo,
}) => {
    switch (layoutExperiment) {
        case 'new_layout':
            return (
                <>
                    <Banner
                        organizerId={organizerId}
                        hasPermissionToEditOrganizationInfo={
                            hasPermissionToEditOrganizationInfo
                        }
                    />
                    <div className="organizer-profile-new-layout-wrapper__container">
                        {children}
                    </div>
                </>
            );
        case 'control':
        default:
            return <>{children}</>;
    }
};
